import { Component, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { GlobalConstants, WebAPIConstants } from 'src/app/services/globalConstants/global-constants.service';
import { PoliticaCalidadComponent } from '../politicaCalidad/politica-calidad.component';
import { Router } from '@angular/router';
import { AvisoPrivacidadComponent } from '../avisoPrivacidad/aviso-privacidad.component';
import { TerminoCondicionComponent } from '../terminosCondiciones/terminos-condiciones.component';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss'],
})
export class FooterComponent implements OnInit {

  //#region " Propiedades "

  public _appVersion: string;
  public _webAPIUrl: string;

  isModalOpen = false;

  //#endregion

  //#region " Constructor "

  constructor(
    private _modalCtrl: ModalController, private router: Router
  ) {
    this._appVersion = GlobalConstants.APP_VERSION;
    this._webAPIUrl = WebAPIConstants.URLServer;
  }

  //#endregion

  //#region " Enventos NG "

  public ngOnInit() {}

  //#endregion

  //#region " Eventos Botones "

  public btnFacebookClick() {
    window.open(GlobalConstants.URL_FACEBOOK, '_new');
  }

  public btnInstagramClick() {
    window.open(GlobalConstants.URL_INSTAGRAM, '_new');
  }

  //#endregion

  // region "Modal"

  public async openTerminos() {
    const terminosCondiciones = await this._modalCtrl.create({
      component: TerminoCondicionComponent,
      cssClass: 'modalCtrl',
    });
    await terminosCondiciones.present();
  }

  public async openAviso() {
    const avisoPrivacidad = await this._modalCtrl.create({
      component: AvisoPrivacidadComponent,
      cssClass: 'modalCtrl',
    });
    await avisoPrivacidad.present();
  }

  public async openPolitica() {
    const politicaCalidad = await this._modalCtrl.create({
      component: PoliticaCalidadComponent,
      cssClass: 'modalCtrl',
    });
    await politicaCalidad.present();
  }
  // endregion
}
